/**
 * 「AIに聞く」パネル上部に常時表示する免責表示コンポーネント。
 * AIの回答が参考情報に過ぎないことをユーザーに常に意識させる目的で、
 * 会話の有無に関わらず固定表示する。
 */
const ChatDisclaimer = () => (
  <div className="ai-disclaimer">
    <span className="ai-disclaimer-icon">⚠️</span>
    <p className="ai-disclaimer-text">AIの回答は参考情報です。内容の正確性・完全性を保証するものではありません。</p>
  </div>
);

export default ChatDisclaimer;
